import React from 'react'
import { FaArrowLeft } from 'react-icons/fa'
import styles from './styles.module.less'

export interface LeftArrowLinkButtonProps {
  linkText: string
  onClick: (event: React.MouseEvent) => void
}

const LeftArrowLinkButton = ({ linkText, onClick }: LeftArrowLinkButtonProps) => (
  <button className={`left-arrow-link-button ${styles.leftArrowLinkButton}`} onClick={onClick}>
    <FaArrowLeft size="1.25rem" />
    <span className={styles.linkText}>{linkText}</span>
  </button>
)

export default LeftArrowLinkButton
